import React from 'react'
import { Routes, Route, useLocation }   from "react-router-dom";
import { Container }       from "react-bootstrap";
import Dashboard           from '../components/Dashboard';
import AccessPointAdmin    from '../components/AccessPointAdmin';
import ActionAdmin         from '../components/ActionAdmin';
import AlarmCategoryAdmin  from '../components/AlarmCategoryAdmin';
import AlarmRuleAdmin      from '../components/AlarmRuleAdmin';
import AppAdmin            from '../components/AppAdmin';
import AssetAdmin          from '../components/AssetAdmin';
import AssetCollAdmin      from '../components/AssetCollAdmin';
import AssetImportAdmin    from '../components/AssetImportAdmin';
import AssetTypeAdmin      from '../components/AssetTypeAdmin';
import BatchDataProcAdmin  from '../components/BatchDataProcAdmin';
import BizConfigAdmin      from '../components/BizConfigAdmin';
import CalConfigAdmin      from '../components/CalConfigAdmin';
import CarparkSpaceAdmin   from '../components/CarparkSpaceAdmin';
import CCTVCamAdmin        from '../components/CCTVCamAdmin';
import DataInspectAdmin    from '../components/DataInspectAdmin';
import DatapointAdmin      from '../components/DatapointAdmin';
import DatapointTypeAdmin  from '../components/DatapointTypeAdmin';
import DatasourceAdmin     from '../components/DatasourceAdmin';
import DeptAdmin           from '../components/DeptAdmin';
import DeviceAdmin         from '../components/DeviceAdmin';
import DocAdmin            from '../components/DocAdmin';
import FloorAdmin          from '../components/FloorAdmin';
import JobAdmin            from '../components/JobAdmin';
import LiftAdmin           from '../components/LiftAdmin';
import LocationAdmin       from '../components/LocationAdmin';
import ModelAdmin          from '../components/ModelAdmin';
import ModelObjAdmin       from '../components/ModelObjAdmin';
import MsgTmplAdmin        from '../components/MsgTmplAdmin';
import NotifAdmin          from '../components/NotifAdmin';
import NotifTypeAdmin      from '../components/NotifTypeAdmin';
import ObjFlagAdmin        from '../components/ObjFlagAdmin';
import PermissionAdmin     from '../components/PermissionAdmin';
import RefDataMgmtAdmin    from '../components/RefDataMgmtAdmin';
import RoleAdmin           from '../components/RoleAdmin';
import SaasTenantAdmin     from '../components/SaasTenantAdmin';
import Sidebar             from '../components/Sidebar';
import ServiceAdmin        from '../components/ServiceAdmin';
import SoundAdmin          from '../components/SoundAdmin';
import SubsAdmin           from '../components/SubsAdmin';
import SubsystemAdmin      from '../components/SubsystemAdmin';
import UiAppAdmin          from '../components/UiAppAdmin';
import UiCompAdmin         from '../components/UiCompAdmin';
import UiCompTypeAdmin     from '../components/UiCompTypeAdmin';
import UserAdmin           from '../components/UserAdmin';
import UserGroupAdmin      from '../components/UserGroupAdmin';
import UserMgmtConfigAdmin from '../components/UserMgmtConfigAdmin';
import UserProfile         from '../components/UserProfile';
//import Console             from '../components/Console';
import DatakeyAdmin        from '../components/DatakeyAdmin';
import DatakeyAudit        from '../components/DatakeyAudit';
//import OpsAudit            from '../components/OpsAudit';


const AdminHome = (props) => {

  const handleMenuItem = (menuItem) => {
    // ### Place holder.  May never need. ###
  }

  var MenuOpen, MenuItemOpen;


  // ##### HACK #####
  const currentUserInfo = localStorage.getItem("currentUserInfo");

  const userType = (currentUserInfo ? JSON.parse(currentUserInfo).userType : '');
  const showSidebar = userType ? (userType !== 'BLDG_TECH') : true;

  const { key } = useLocation()


  return (

    <Container style={{display:'flex', backgroundColor:'#475B65', maxWidth:'2500px', width:'100%', height:'1100px', margin: '0', padding:'0px', border: '0' }}>

      {showSidebar ? <Sidebar onMenuItemSelect={handleMenuItem} menuOpen={MenuOpen} menuItemOpen={MenuItemOpen} /> : null}

      <Container style={{padding:'5px', marginLeft:'0px'}}>
      <Routes>
        <Route exact path="/Dashboard"            element={< Dashboard           key={key} />}></Route>
        <Route exact path="/AccessPointAdmin"     element={< AccessPointAdmin    key={key} />}></Route>
        <Route exact path="/ActionAdmin"          element={< ActionAdmin         key={key} />}></Route>
        <Route exact path="/AlarmCategoryAdmin"   element={< AlarmCategoryAdmin  key={key} />}></Route>
        <Route exact path="/AlarmRuleAdmin"       element={< AlarmRuleAdmin      key={key} />}></Route>
        <Route exact path="/AppAdmin"             element={< AppAdmin            key={key} />}></Route>
        <Route exact path="/AssetAdmin"           element={< AssetAdmin          key={key} />}></Route>
        <Route exact path="/AssetCollAdmin"       element={< AssetCollAdmin      key={key} />}></Route>
        <Route exact path="/AssetImportAdmin"     element={< AssetImportAdmin    key={key} />}></Route>
        <Route exact path="/AssetTypeAdmin"       element={< AssetTypeAdmin      key={key} />}></Route>
        <Route exact path="/BatchDataProcAdmin"   element={< BatchDataProcAdmin  key={key} />}></Route>
        <Route exact path="/BizConfigAdmin"       element={< BizConfigAdmin      key={key} />}></Route>
        <Route exact path="/CalConfigAdmin"       element={< CalConfigAdmin      key={key} />}></Route>
        <Route exact path="/CarparkSpaceAdmin"    element={< CarparkSpaceAdmin   key={key} />}></Route>
        <Route exact path="/CCTVCamAdmin"         element={< CCTVCamAdmin        key={key} />}></Route>
        <Route exact path="/DataInspectAdmin"     element={< DataInspectAdmin    key={key} />}></Route>
        <Route exact path="/DatakeyAdmin"         element={< DatakeyAdmin                  />}></Route>
        <Route exact path="/DatakeyAudit"         element={< DatakeyAudit                  />}></Route>
        <Route exact path="/DatapointAdmin"       element={< DatapointAdmin      key={key} />}></Route>
        <Route exact path="/DatapointTypeAdmin"   element={< DatapointTypeAdmin  key={key} />}></Route>
        <Route exact path="/DatasourceAdmin"      element={< DatasourceAdmin     key={key} />}></Route>
        <Route exact path="/DeptAdmin"            element={< DeptAdmin           key={key} />}></Route>
        <Route exact path="/DeviceAdmin"          element={< DeviceAdmin         key={key} />}></Route>
        <Route exact path="/DocAdmin"             element={< DocAdmin            key={key} />}></Route>
        <Route exact path="/FloorAdmin"           element={< FloorAdmin          key={key} />}></Route>
        <Route exact path="/JobAdmin"             element={< JobAdmin            key={key} />}></Route>
        <Route exact path="/LiftAdmin"            element={< LiftAdmin           key={key} />}></Route>
        <Route exact path="/LocationAdmin"        element={< LocationAdmin       key={key} />}></Route>
        <Route exact path="/ModelAdmin"           element={< ModelAdmin          key={key} />}></Route>
        <Route exact path="/ModelObjAdmin"        element={< ModelObjAdmin       key={key} />}></Route>
        <Route exact path="/MsgTmplAdmin"         element={< MsgTmplAdmin        key={key} />}></Route>
        <Route exact path="/NotifAdmin"           element={< NotifAdmin          key={key} />}></Route>
        <Route exact path="/NotifTypeAdmin"       element={< NotifTypeAdmin      key={key} />}></Route>
        <Route exact path="/ObjFlagAdmin"         element={< ObjFlagAdmin        key={key} />}></Route>
        <Route exact path="/PermissionAdmin"      element={< PermissionAdmin     key={key} />}></Route>
        <Route exact path="/RefDataMgmtAdmin"     element={< RefDataMgmtAdmin    key={key} />}></Route>
        <Route exact path="/RoleAdmin"            element={< RoleAdmin           key={key} />}></Route>
        <Route exact path="/SaasTenantAdmin"      element={< SaasTenantAdmin     key={key} />}></Route>
        <Route exact path="/ServiceAdmin"         element={< ServiceAdmin        key={key} />}></Route>
        <Route exact path="/SoundAdmin"           element={< SoundAdmin          key={key} />}></Route>
        <Route exact path="/SubsAdmin"            element={< SubsAdmin           key={key} />}></Route>
        <Route exact path="/SubsystemAdmin"       element={< SubsystemAdmin      key={key} />}></Route>
        <Route exact path="/UiAppAdmin"           element={< UiAppAdmin          key={key} />}></Route>
        <Route exact path="/UiCompAdmin"          element={< UiCompAdmin         key={key} />}></Route>
        <Route exact path="/UiCompTypeAdmin"      element={< UiCompTypeAdmin     key={key} />}></Route>
        <Route exact path="/UserAdmin"            element={< UserAdmin           key={key} />}></Route>
        <Route exact path="/UserGroupAdmin"       element={< UserGroupAdmin      key={key} />}></Route>
        <Route exact path="/UserMgmtConfigAdmin"  element={< UserMgmtConfigAdmin key={key} />}></Route>
        <Route exact path="/UserProfile"          element={< UserProfile         key={key} />}></Route>
{/*
        <Route exact path="/Console"              element={< Console />}></Route>
        <Route exact path="/OpsAudit"             element={< OpsAudit />}></Route>
*/}
      </Routes>
      </Container>
    </Container>
  )
}

export default AdminHome;
